<template>
  <b-container fluid>
    <div class="my-2">
      <label for="jis-title">Title:</label>
      <b-form-input
        id="jis-title"
        v-model="jobInformationSet.title"
        placeholder="Enter Title"
      />
      <b-form-text>
        Title of this Job Information Set. Will not be inserted to Job
        Information section.
      </b-form-text>
    </div>
    <div class="my-2">
      <label for="jis-job-title">Job Title:</label>
      <b-form-input
        id="jis-job-title"
        v-model="jobInformationSet.job_title"
        placeholder="Enter Job Title"
      />
      <b-form-text>
        Job Title will be inserted to Job Information section.
      </b-form-text>
    </div>
    <div class="my-2">
      <label for="jis-description">Description:</label>
      <b-form-textarea
        id="jis-description"
        v-model="jobInformationSet.description"
        placeholder="Description"
      />
    </div>
    <div class="my-2">
      <label for="jis-welcome-message">Welcome message:</label>
      <b-form-textarea
        id="jis-welcome-message"
        v-model="jobInformationSet.welcome_message"
        placeholder="Welcome message"
      />
    </div>
    <div class="my-2">
      <label for="jis-tracking-num">PO or Tracking #:</label>
      <b-form-input
        id="jis-tracking-num"
        v-model="jobInformationSet.tracking_num"
        placeholder="Enter PO or Tracking #"
      />
    </div>
    <div class="my-2">
      <label for="jis-external-url">Job board URL</label>
      <b-form-input
        id="jis-external-url"
        v-model="jobInformationSet.external_url"
        placeholder="Enter Job board URL"
      />
    </div>
    <div>
      <label for="jis-company-name">Company</label>
      <b-form-input
        id="jis-company-name"
        v-model="jobInformationSet.company_name"
        placeholder="Enter Company"
      />
    </div>
    <div class="my-2">
      <label for="jis-location-zip-code">Job Location Zip Code</label>
      <b-form-input
        id="jis-location-zip-code"
        v-model="jobInformationSet.location_zip_code"
        placeholder="Enter Job Location Zip Code"
      />
      <b-form-text> 5 digits </b-form-text>
    </div>
    <div class="d-flex">
      <b-button variant="v3_teal_outline" :disabled="saveLoading" @click="save">
        <b-spinner v-if="saveLoading" small />
        <span v-else>Save</span>
      </b-button>
      <b-button
        v-if="jobInformationSet.id"
        variant="v3_red_outline"
        class="ml-2"
        :disabled="removeLoading"
        @click="remove"
      >
        <b-spinner v-if="removeLoading" small />
        <span v-else>Remove</span>
      </b-button>
    </div>
  </b-container>
</template>

<script>
export default {
  name: 'JobInformationSetForm',
  props: {
    jobInformationSet: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      default: null,
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
    removeLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    save: function () {
      this.$emit('save-job-information-set', this.jobInformationSet);
    },
    remove: function () {
      this.$emit('remove-job-information-set', this.jobInformationSet.id);
    },
  },
};
</script>

<style scoped></style>
